import { Helmet } from "react-helmet-async";
import { HOTEL } from "@/data/site";

const SITE = "https://super8ottawa.com";

export const Seo = ({
  title,
  description,
  path = "/",
  image = "/images/exterior.jpg",
  breadcrumbs = [],
  faqs = [],
}) => {
  const url = `${SITE}${path}`;
  const ogImage = image.startsWith("http") ? image : `${SITE}${image}`;
  const fullTitle = `${title} | ${HOTEL.name}`;

  const hotelSchema = {
    "@context": "https://schema.org",
    "@type": "Hotel",
    name: HOTEL.name,
    description,
    url,
    telephone: HOTEL.phone,
    priceRange: "$$",
    image: ogImage,
    starRating: { "@type": "Rating", ratingValue: "2" },
    address: {
      "@type": "PostalAddress",
      streetAddress: HOTEL.addressLine,
      addressLocality: HOTEL.city,
      addressRegion: HOTEL.state,
      postalCode: HOTEL.zip,
      addressCountry: HOTEL.country,
    },
    geo: { "@type": "GeoCoordinates", latitude: HOTEL.lat, longitude: HOTEL.lng },
    amenityFeature: [
      "Indoor Pool", "Free Breakfast", "Free WiFi", "Truck Parking",
      "RV Parking", "Guest Laundry", "24-Hour Front Desk", "Accessible Rooms",
    ].map((n) => ({ "@type": "LocationFeatureSpecification", name: n, value: true })),
  };

  const breadcrumbSchema = breadcrumbs.length
    ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${SITE}${b.path}`,
        })),
      }
    : null;

  const faqSchema = faqs.length
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 20).map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }
    : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={HOTEL.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <script type="application/ld+json">{JSON.stringify(hotelSchema)}</script>
      {breadcrumbSchema && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      )}
      {faqSchema && (
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      )}
    </Helmet>
  );
};
